export const INTRO_CONSTANTS = {
  title: "ZTNA | VPN | NGFW | SASE — One Platform to Secure Every Connection",
  text: "Legacy perimeter-based models no longer secure today’s distributed teams. OneMind delivers a Zero Trust-based Secure Network Access framework that verifies identity, inspects traffic in real time, and enforces dynamic access control — across users, devices, clouds, and locations. ",
};
